import CourseListPage from "./CourseListPage";

export default function AdminWorkshops() {
  return (
    <CourseListPage
      kind="normal"
      pageTitle="Talleres"
      pageSubtitle="Crea talleres (examen único), impórtalos desde JSON, y asígnalos a usuarios."
      newItemLabel="Nuevo taller"
      newItemPath="/admin/workshops/new"
      editPathFor={(id) => `/admin/workshops/${id}/edit`}
      importLabel="Importar taller (JSON)"
      showTemasColumn={false}
      deleteConfirmLabel="¿Eliminar este taller? Se eliminarán intentos y asignaciones."
      emptyRowTestId="no-workshops"
    />
  );
}
